<div class="mt-6 grid grid-cols-2 gap-4">
    <app-input-text
        [errors]="axisFormInputs().errors.xAxisTitleText"
        [inputFormControl]="axisFormInputs().controls.xAxisTitleText"
        [label]="`${('statistic.xAxisTitle' | transloco)}*`"
        [placeholder]="'statistic.enterXAxisTitle' | transloco" />

    <app-input-text
        [errors]="axisFormInputs().errors.xAxisUnit"
        [inputFormControl]="axisFormInputs().controls.xAxisUnit"
        [label]="'unit' | transloco"
        [placeholder]="'enterUnit' | transloco" />

    <app-input-text
        [errors]="axisFormInputs().errors.yAxisTitleText"
        [inputFormControl]="axisFormInputs().controls.yAxisTitleText"
        [label]="`${('statistic.yAxisTitle' | transloco)}*`"
        [placeholder]="'statistic.enterYAxisTitle' | transloco" />

    <app-input-text
        [errors]="axisFormInputs().errors.yAxisUnit"
        [inputFormControl]="axisFormInputs().controls.yAxisUnit"
        [label]="'unit' | transloco"
        [placeholder]="'enterUnit' | transloco" />
</div>
